var map = {
	"./music-instructions.json": 3551,
	"./music-library-intro2024.json": 3552,
	"./music-library-launch2024.json": 3553,
	"./music-progression.json": 3554,
	"./startSourcesAdvanced.json": 3555,
	"./startSourcesSimple.json": 3556,
	"./startSourcesSimple2.json": 3557,
	"./startSourcesTracks.json": 3558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3412;